import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchProdukteReceivedToPreselectOeltank } from './preselectOeltankSaga';
import { streckenTarifierungVWG } from './streckenTarifierungVWG';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchToggleProduktlinienActiveTrigger } from './toggleProduktlinienActiveStateSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { shopTarifierungVWG } from './shopTarifierungVWG';
import { watchVorversicherungVorhandenChanged } from './vorversicherungVorhandenChangedSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { handleVwgNavigationToAngebotSaga } from './handleVwgNavigationToAngebotSaga';
import { provideStructuredRisikoortSaga } from './provideStructuredRisikoortSaga';
import { updateRisikoortAfterLoadAzamSaga } from './updateRisikoortAfterLoadAzamSaga';
import { extremWetterSchutzVorbelegenSaga } from './extremWetterSchutzVorbelegenSaga';
import { watchResetAdressdatenRequested } from './resetAdressdatenSaga';
import { watchRisikoortRequested } from './risikoortSaga';
import { watchPlzRequiresUwCheck } from './plzRequiresUwCheckSaga';
import { watchPlzRequiresUwSubmissionBlocked } from './plzRequiresUwBlockedSaga';
import { extremWetterschutzSelbstbeteiligungSaga } from './extremWetterschutzSelbstbeteiligungSaga';
import { watchBeibehaltungProduktRequested } from './beibehaltungProduktSaga';
import { watchConfirmUwApprovedOfferEdition } from './confirmUwApprovedOfferEditionSaga';
import { watchReevaluateUwRequirednessAfterLoad } from './reevaluateUwRequirednessAfterLoadSaga';
import { watchCorrectFeuerrohbau } from './correctFeuerrohbauSaga';

export function* rootSaga() {
  yield all([
    streckenTarifierungVWG(),
    shopTarifierungVWG(),
    watchVorschlagdatenChanged(),
    watchAntragsnummerRequested(),
    watchProdukteReceivedToPreselectOeltank(),
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    watchDruckdatenChanged(),
    watchToggleProduktlinienActiveTrigger(),
    watchInDashboardUebernehmenSaga(),
    watchVorversicherungVorhandenChanged(),
    watchQuoteDB(),
    watchVorbelegungRequested(),
    handleVwgNavigationToAngebotSaga(),
    provideStructuredRisikoortSaga(),
    updateRisikoortAfterLoadAzamSaga(),
    extremWetterSchutzVorbelegenSaga(),
    watchResetAdressdatenRequested(),
    watchRisikoortRequested(),
    watchPlzRequiresUwCheck(),
    watchPlzRequiresUwSubmissionBlocked(),
    extremWetterschutzSelbstbeteiligungSaga(),
    watchConfirmUwApprovedOfferEdition(),
    watchBeibehaltungProduktRequested(),
    watchReevaluateUwRequirednessAfterLoad(),
    watchCorrectFeuerrohbau(),
  ]);
}
